import Client from './client';

export default class MarketingGatewayFacebookConnections extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  get(organization, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/marketing/gateway/facebook`, options);
  }

  put(organization, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/marketing/gateway/facebook`, {
      ...options,
       method: 'PUT',
    });
  }

  delete(organization, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/marketing/gateway/facebook`, {
      ...options,
       method: 'DELETE',
    });
  }

  putCatalog(organization, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/marketing/gateway/facebook/catalog`, {
      ...options,
       method: 'PUT',
    });
  }

}
